import React from 'react';
import { RoutePermittedRole } from '../../shared/constants/AppEnums';
import CreateOrEditBanner from './banners/create-or-edit-banners';
import { promotionsNewsLetterConfig } from './news-letter';

const BannersList = React.lazy(() => import('./banners'));
const GeneralCoupons = React.lazy(() => import('./general-coupons'));
const CreateCoupon = React.lazy(() => import('./general-coupons/create-coupon'));
const CouponDetails = React.lazy(() => import('./general-coupons/coupon-details'));
const EditCoupon = React.lazy(() => import('./general-coupons/edit-coupon'));
const AdminOffers = React.lazy(() => import('./admin-offers'));
const PushCampaignsList = React.lazy(() => import('./push-campaigns'));
const CreateOrEditPushCampaign = React.lazy(
  () => import('./push-campaigns/create-or-edit-push-campaign'),
);

export const promotionsConfig = [
  ...promotionsNewsLetterConfig,
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/banners',
    element: <BannersList />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/general-coupons',
    element: <GeneralCoupons />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/general-coupons/create',
    element: <CreateCoupon />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/general-coupons/details/:id',
    element: <CouponDetails />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/general-coupons/edit/:id',
    element: <EditCoupon />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/admin-offers',
    element: <AdminOffers />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/banners/create-banner',
    element: <CreateOrEditBanner />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/banners/edit-banner/:id',
    element: <CreateOrEditBanner />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/push-campaigns',
    element: <PushCampaignsList />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/push-campaigns/create',
    element: <CreateOrEditPushCampaign />,
  },
  {
    permittedRole: RoutePermittedRole.user,
    path: '/promotions/push-campaigns/edit/:id',
    element: <CreateOrEditPushCampaign />,
  },
];
